import { Controller } from "stimulus"
import Tooltip from "tooltip.js";

export default class extends Controller {
    connect() {
        var tooltips = Array.from(this.element.querySelectorAll('[data-tooltip]'))

        tooltips.forEach(element => {
            new Tooltip(element, {
                title: element.dataset.tooltip,
                container: 'body',
                template: '<div class="staff-toolbar-tooltip" role="tooltip">' +
                          '<div class="staff-toolbar-tooltip-arrow"></div>' +
                          '<div class="staff-toolbar-tooltip-inner"></div>' +
                          '</div>',
                arrowSelector: '.staff-toolbar-tooltip-arrow',
                innerSelector: '.staff-toolbar-tooltip-inner',
                trigger: 'hover'
            })
        })
    }
}
